/**
 * Returns the action option ({ value, label, requiresPin, userField? }) for the given action, or undefined.
 * Pure — operates on the passed actionOptions (no config lookup), so components can use it with an actionOptions prop.
 * @param {Array} actionOptions - the capability's action options (from config)
 * @param {string} action - state token
 * @returns {Object|undefined}
 */
export const getActionOption = (actionOptions, action) => {
    return actionOptions?.find((option) => option.value === action);
};
